import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import siteAnalyticsAction from 'yoda-site-components/lib/actions/AnalyticsAction';
import {
    ANALYTICS_ACTIONS_PLCC_DYN_BANNER_GET_DETAIL,
    PLCC_DYN_BANNER_EMPTY_CART_CODE,
    PLCC_DYN_BANNER_APPLY_AND_BUY_CODE,
    PLCC_DYN_BANNER_PROMO_FINANCE_CODE,
    PLCC_CREDIT_UPSELL_VIEWS,
} from 'yoda-checkout-components/lib/common/Constants';
import * as CheckoutAnalyticsAction from 'yoda-checkout-components/lib/actions/CheckoutAnalyticsAction';
import * as CartAnalyticsAction from 'yoda-checkout-components/lib/actions/CartAnalyticsAction';
import DigitalAnalyticsHelper from 'yoda-checkout-components/lib/analytics/DigitalAnalyticsHelper';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import PLCCDynamicBannerMode from './PLCCDynamicBannerMode';
import { getPLCCBannerHtml, getPLCCDetailsHtml } from '../../actions/PlccDynamicBannerAction';

export class PLCCDynamicBanner extends Component {
    static defaultProps = {
        plccDynamicBanner: {
            code: '',
            isPromoFinancing: true,
            bccHtmlUrl: '',
            savingsPercentage: 5,
            subTotal: '0000.00',
            estSavings: '0000.00',
            afterSavings: '0000.00',
        },
        deviceType: {},
    };

    static propTypes = {
        plccDynamicBanner: PropTypes.objectOf(PropTypes.any),
        actions: PropTypes.objectOf(PropTypes.func).isRequired,
        deviceType: PropTypes.objectOf(PropTypes.object),
        initialRender: PropTypes.bool.isRequired,
        togglePLCCDetailSlider: PropTypes.func.isRequired,
    };

    constructor() {
        super();
        this.handleDetailsClick = this.handleDetailsClick.bind(this);
    }

    componentDidMount() {
        if (this.props.initialRender) {
            const { plccDynamicBanner } = this.props;
            if (!isEmpty(plccDynamicBanner.contentLink)) {
                this.props.actions.getPLCCBannerHtml(plccDynamicBanner.contentLink.url);
                if (plccDynamicBanner.bannerUpdated) {
                    const bannerName = DigitalAnalyticsHelper.getPlccBannerName(plccDynamicBanner);
                    this.props.actions.plccBannerUpdateAction(bannerName);
                }
            }
            const payload = {
                eventName: PLCC_CREDIT_UPSELL_VIEWS,
                eventData: { plccBanner: this.getBannerName(plccDynamicBanner.code) },
            };
            this.props.actions.plccClickEventAction(payload);
        }
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillUpdate(nextProps) {
        const { plccDynamicBanner } = nextProps;
        const curPlccDynamicBanner = this.props.plccDynamicBanner;
        const curContentUrl =
            curPlccDynamicBanner.contentLink && curPlccDynamicBanner.contentLink.url;
        const curDetailUrl =
            curPlccDynamicBanner.detailsLink && curPlccDynamicBanner.detailsLink.url;
        if (
            this.props.plccDynamicBanner !== plccDynamicBanner &&
            !isEmpty(plccDynamicBanner.contentLink) &&
            curContentUrl !== plccDynamicBanner.contentLink.url
        ) {
            nextProps.actions.getPLCCBannerHtml(plccDynamicBanner.contentLink.url);
            if (
                plccDynamicBanner.bannerUpdated &&
                plccDynamicBanner.code !== PLCC_DYN_BANNER_EMPTY_CART_CODE
            ) {
                const bannerName = DigitalAnalyticsHelper.getPlccBannerName(plccDynamicBanner);
                this.props.actions.plccBannerUpdateAction(bannerName);
            }
        }
        if (
            !isEmpty(plccDynamicBanner.detailsLink) &&
            curDetailUrl !== plccDynamicBanner.detailsLink.url
        ) {
            nextProps.actions.getPLCCDetailsHtml(plccDynamicBanner.detailsLink.url);
        }
    }

    handleDetailsClick(openPLCCDetails) {
        const { plccDynamicBanner } = this.props;
        this.props.togglePLCCDetailSlider(openPLCCDetails);
        // Analytics for learnmore
        const bannerName = this.getBannerName(plccDynamicBanner.code);
        if (openPLCCDetails) {
            this.props.actions.openModelEvent({
                name: ANALYTICS_ACTIONS_PLCC_DYN_BANNER_GET_DETAIL,
            });
        }
        const payload = {
            eventName: 'plccgetdetails',
            eventData: { plccBanner: bannerName },
        };
        this.props.actions.plccClickEventAction(payload);
        this.props.actions.triggerPlccAnalytics({
            name: `cart plcc apply & buy : ${this.getPlccBannerType(plccDynamicBanner)}`,
            linktext: 'learnmore',
        });
    }

    getBannerName = (bannerCode) => {
        let plccBannerName;
        if (bannerCode === PLCC_DYN_BANNER_APPLY_AND_BUY_CODE) {
            plccBannerName = 'dynamic_apply_sf';
        }
        if (bannerCode === PLCC_DYN_BANNER_PROMO_FINANCE_CODE) {
            plccBannerName = 'dynamic_apply';
        }
        return plccBannerName;
    };

    getPlccBannerType = (plccDynamicBanner) => {
        const { code } = plccDynamicBanner;
        let bannerType;
        if (code === PLCC_DYN_BANNER_APPLY_AND_BUY_CODE) {
            bannerType = 'dynamic';
        }
        if (code === PLCC_DYN_BANNER_PROMO_FINANCE_CODE) {
            bannerType = 'dynamic with special financing';
        }
        return bannerType;
    };

    handleCheckNowAnalytics = (e) => {
        const { plccDynamicBanner } = this.props;
        const plccURL = e.target.href;
        const bannerName = this.getBannerName(plccDynamicBanner.code);
        const payload = {
            plccBanner: bannerName,
        };
        this.props.actions.newPlccEventAnalyticsAction({
            name: `cart: see if you prequalify : ${bannerName}`,
            linktext: 'Check Now',
            locationpath: plccURL,
        });
        this.props.actions.plccApplyAnalytics(payload);
        this.props.actions.triggerPlccAnalytics({
            name: `cart plcc apply & buy : ${this.getPlccBannerType(plccDynamicBanner)}`,
            linktext: 'check now',
        });
        window.open(plccURL, '_blank');
    };

    render() {
        const { plccDynamicBanner, deviceType, initialRender } = this.props;
        return (
            <div
                data-automation-id="plcc-dynamic-banner"
                className={dt([
                    'lg:p-6',
                    'smMd:pt-4',
                    'smMd:pb-2',
                    'mdOnly:px-0',
                    'smMd:mx-auto',
                    'smMd:my-0',
                    'smMd:max-w-[373px]',
                    'smMd:border-none',
                ])}
            >
                <PLCCDynamicBannerMode
                    bccHtmlUrl={plccDynamicBanner.bccHtmlUrl}
                    savings={plccDynamicBanner.savingsPercentage}
                    minSavings={plccDynamicBanner.savingsMinPercentage}
                    subTotal={plccDynamicBanner.subTotal}
                    bannerHtml={plccDynamicBanner.bannerHtml}
                    estSavings={plccDynamicBanner.estSavings}
                    afterSavings={plccDynamicBanner.afterSavings}
                    handleDetailsClick={this.handleDetailsClick}
                    handleCheckNowAnalytics={this.handleCheckNowAnalytics}
                    bannerCode={plccDynamicBanner.code}
                    isPromoFinancing={plccDynamicBanner.isPromoFinancing}
                    deviceType={deviceType}
                    registerDetailsLinkAction={initialRender}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { plccDynamicBanner } = state;
    const deviceType = get(state, 'context.deviceType');
    return {
        plccDynamicBanner,
        deviceType,
    };
};
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            getPLCCBannerHtml,
            getPLCCDetailsHtml,
            ...CheckoutAnalyticsAction,
            ...siteAnalyticsAction,
            ...CartAnalyticsAction,
        },
        dispatch
    ),
});
export default connect(mapStateToProps, mapDispatchToProps)(PLCCDynamicBanner);
